<template>
  <div class="modal" :class="{ 'is-active': abierto }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Educa Digital 2019</p>
        <button class="delete" aria-label="close" @click="cerrar"></button>
      </header>
      <section class="modal-card-body" v-html="html"></section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="cerrar">Aceptar</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ["html"],
  data() {
    return {
      open: true
    };
  },
  computed: {
    abierto() {
      return this.open && !(this.html == "" || this.html == null);
    }
  },
  methods: {
    cerrar() {
      this.open = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
